package br.com.vvrefeicoes.portal.domain.repository

data class CepAddress(
    val street: String,
    val neighborhood: String,
    val city: String,
    val state: String,
)

interface CepRepository {
    suspend fun lookup(cep: String): CepAddress?
}
